export function stepLoadingFile (proxy)
{
    // Получаем объект с LocalStorage
    const step = 'step'+proxy.data.step;
    const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    const fvcContainerId = proxy.fvcContainerId;
    const messageHtml = proxy.data.messageHtml;
    const htmlText = proxy.data.htmlText;

    const fileWrapper = fvcContainerId.querySelector('.download_file_wrapper');
    const input = fileWrapper.querySelector('.input_control_js');
    const inputNameFile = fileWrapper.querySelector('.input_name_file');
    const inputContainer = fileWrapper.querySelector('.cont_left .input_container');
    const contRight = fileWrapper.querySelector('.cont_right');
    const downloadFileBtnSpan = fileWrapper.querySelector('.download_file_btn span');

    const success = fileWrapper.classList.contains('_success');
    const error = fileWrapper.classList.contains('_error');

    // Если есть массив с данными то отображаем их
    if (!success && dataLocalStorage.files) {
        fileWrapper.classList.add('_success');
        inputNameFile.innerText = dataLocalStorage.name;

        inputContainer.insertAdjacentHTML("beforeend", htmlText('SUCCESS_VIEW_FILE'));
        contRight.insertAdjacentHTML("beforeend", htmlText('SUCCESS_DELETE_FILE'));
        downloadFileBtnSpan.innerText = BX.message('SUCCESS_FILE_DOWNLOAD');

        const divViewFile = fileWrapper.querySelector('.view_file');
        const divDeleteFile = fileWrapper.querySelector('.delete_file');
        if (!proxy.bNext.classList.contains('in')) proxy.bNext.classList.add('in');

        // клик "Просмотр файла"
        divViewFile.addEventListener('click', function ()
        {
            inputContainer.insertAdjacentHTML("beforeend", htmlText('MODAL_DIALOG_IMG'));
            const modalDialog = inputContainer.querySelector('.modal_dialog');
            const modalClose = modalDialog.querySelector('.modal_close');
            const imgPreview = modalDialog.querySelector('img');


            // Делаем размер картинки по области просмотра
            const wHeight = window.innerHeight
            imgPreview.style.maxHeight = wHeight - 50 + 'px'

            imgPreview.src = dataLocalStorage.files;

            modalClose.addEventListener('click', function (ev) {
                ev.preventDefault();
                modalDialog.remove();
            })
        });

        // Клик "Удалить файл"
        divDeleteFile.addEventListener('click', function () {
            proxy.data.fileCleaningErrorSuccess(fvcContainerId);
            proxy.data.btnNext = 2
            proxy.data.dataForm[step] = {}
            const modalDialog = inputContainer.querySelector('.modal_dialog');

            downloadFileBtnSpan.innerText = BX.message('ERROR_UPLOAD_FILE');
            inputNameFile.innerText = '';
            if (modalDialog) modalDialog.remove();
            const lcDataFail = {}
            input.value = '';
            proxy.data.filesFlag = false;

            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, lcDataFail, proxy.data.step);
            if (proxy.bNext.classList.contains('in')) proxy.bNext.classList.remove('in');
        })
    } else {
        if (!success && proxy.data.btnNext > 1 && !proxy.data.filesFlag) {
            fileWrapper.classList.add('_error');
            if (!inputContainer.querySelector('.form_additional_text')) {
                inputContainer.insertAdjacentHTML("beforeend", messageHtml('ERROR_UPLOAD_FILE'));
            }
        }
    }

    proxy.data.btnNext = 2
}
